import ColumnFactory from '@/Factories/ColumnFactory';
import ComponentManager from '@/Management/ComponentManager';

export default class CheckBoxColumnFactory extends ColumnFactory {

    public static isPlainText = false;
    public static isJQueryElement = true;

    constructor(params: any) {
        super(params);
    }

    public getValue(): HTMLElement {
        let checked = this.raw as boolean;
        let text = checked ? '&#10003;' : '';

        var cb = document.createElement('div');
        cb.className = 'c-control c-checkbox c-style-default  c-state-disabled c-gridCell';
        cb.dataset.checked = '' + checked;

        var inner_cb = document.createElement('div');
        inner_cb.className = 'element';
        inner_cb.tabIndex = 0;
        inner_cb.innerHTML = text;

        cb.appendChild(inner_cb);

        return cb;
    }
}

ComponentManager.setFactory('CheckBoxColumn', CheckBoxColumnFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');